<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrOdenekTalep from "@/models/StrOdenekTalep";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import Treeselect from "@riophae/vue-treeselect";
import moment from "moment";
import store from "@/state/store";
import Swal from "sweetalert2";
const simulateAsyncOperation = (fn) => {
  setTimeout(fn, 500);
};

export default {
  mixins: [Api, Sabit, StrOdenekTalep],
  props: ["Id", "AddEdit"],
  data() {
    return {
      UserEmail : store.getters["auth/UserEMail"],
      OPersonelid: null,
      FormData: {},
      FormDatas: [],
      Hesapkoduids: [],
      Strperformanshedefiid: "",
      Strtabdetfaaliyetid: "",
      guncele: "Add",
      file: "",
      aktif_arama: false,
      AdminRoleKontrol: false,
      Tarih: moment(new Date()).format("YYYY-MM-DD"),
      Page : {
        PageNumber: "1",
        PageSize: "9999",
      },
      Hesapkodlari: [],
      Hesapkodlari2: [],
            TabloDetayVerileri: [],
      Yillar:[
          {"id":"2023","value":"2023"},
          {"id":"2024","value":"2024"},
          {"id":"2025","value":"2025"},
          {"id":"2026","value":"2026"},
          {"id":"2027","value":"2027"},
          {"id":"2028","value":"2028"},
          {"id":"2029","value":"2029"},
          {"id":"2030","value":"2030"},

        ],
    };
  },
  components: {
    Loader,
    forminput,
    formcombobox,
    BirimSecimi,
    // formtreeselect,
    Treeselect,
  },
  watch: {
    Id() {
    this.FormDataType.Yil.ComboDataArray = []
      if (this.AddEdit == "Add") {
        this.aktif_arama = true;
              var currentDate = new Date();
      this.FormDataType.Yil.ComboDataArray=[];
      for (var m=0 ; m<this.Yillar.length; m++){
 var Year =  currentDate.getFullYear()
        if(Year == this.Yillar[m].value){
          this.FormDataType.Yil.ComboDataArray.push ({Id:this.Yillar[m].id,Value:this.Yillar[m].value})
        }


      }
      } else {
        this.aktif_arama = false;
        this.liste_kontrol();

      this.FormDataType.Yil.ComboDataArray=[];
      for (var n=0 ; n<this.Yillar.length; n++){
          this.FormDataType.Yil.ComboDataArray.push ({Id:this.Yillar[n].id,Value:this.Yillar[n].value})
      }
        this.GetFormDatas(this.Id.GrupGuid);

        this.ActionsFilterGet({
          Service: "StrKontrolGirisKanit",
          Page: this.Page,
          Filter: "&Odenekid=" + this.Id.Ids[0],
        }).then((res) => {
          this.TabloDetayVerileri = res.Data;
          this.Page.PageDataSize = res.TotalCount;

        });
      this.FormDataType.Altfaaliyet.ComboDataArray = [];
      let Filter = "&Ustid=" + this.Id.Faaliyet;
      this.ActionsFilterGet({
        Service: "StrProgramFaaliyetKodlari",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        for (var c = 0; c < res.Data.length; c++) {
          this.FormDataType.Altfaaliyet.ComboDataArray.push({
            Id: res.Data[c].Id,
            Value: res.Data[c].Kod + "-" + res.Data[c].Aciklama,
          });
        }
      });
      this.FormDataType.Altprogram.ComboDataArray = [];
      let Filter2 = "&Ustid=" + this.Id.Program;
      this.ActionsFilterGet({
        Service: "StrProgramFaaliyetKodlari",
        Page: this.Page,
        Filter: Filter2,
      }).then((res) => {
        for (var n = 0; n < res.Data.length; n++) {
          this.FormDataType.Altprogram.ComboDataArray.push({
            Id: res.Data[n].Id,
            Value: res.Data[n].Kod + "-" + res.Data[n].Aciklama,
          });
        }
      });
      }
      let Page= {
        PageNumber: "1",
        PageSize: "9999"
      }
            let Filter2 = "&Tip=0";
this.FormDataType.Program.ComboDataArray = []
      this.ActionsFilterGet({Service:"StrProgramFaaliyetKodlari",Page:Page, Filter:Filter2}).then(res => {
        for(var c=0; c<res.Data.length; c++)
          {
            if(res.Data[c].Ustid == null){
            this.FormDataType.Program.ComboDataArray.push ({Id:res.Data[c].Id,Value:res.Data[c].Kod + "-" + res.Data[c].Aciklama})
              }
          }
      });

      let Filter3 = "&Tip=1";
this.FormDataType.Faaliyet.ComboDataArray = []
      this.ActionsFilterGet({Service:"StrProgramFaaliyetKodlari",Page:Page, Filter:Filter3}).then(res => {
        for(var e=0; e<res.Data.length; e++)
          {
            if(res.Data[e].Ustid == null){
            this.FormDataType.Faaliyet.ComboDataArray.push ({Id:res.Data[e].Id,Value:res.Data[e].Kod + "-" + res.Data[e].Aciklama})
              }
          }
      });
      this.FormData = this.Id;
      setTimeout(() => {
        this.aktif_arama = true;
      }, 200);
    },
    FormDatas() {
      this.Hesapkoduids = [];
    },
    'FormData.Gidertur'(newVal) {

        this.HesapKodsMethod(newVal);

    }
  },
  methods: {
    onSubmit() {
      if (this.FormData.Fileurl != "" || this.FormData.Aciklama != "") {
        if (this.AddEdit == "Add") {
          var Guid = this.generateGUID();

          this.FormDatas.forEach((item) => (item.GrupGuid = Guid));
          this.FormDatas.forEach((item) => (item.Created = this.Tarih));
          this.FormDatas.forEach(
            (item) => (item.Birimid = this.FormData.Birimid)
          );
          this.FormDatas.forEach(
            (item) => (item.Gidertur = this.FormData.Gidertur)
          );
          this.FormDatas.forEach((item) => (item.Yil = this.FormData.Yil));
          this.FormDatas.forEach((item) => (item.Ay = this.FormData.Ay));
          this.FormDatas.forEach(
            (item) => (item.Program = this.FormData.Program)
          );
          this.FormDatas.forEach(
            (item) => (item.Altprogram = this.FormData.Altprogram)
          );
          this.FormDatas.forEach(
            (item) => (item.Faaliyet = this.FormData.Faaliyet)
          );
          this.FormDatas.forEach(
            (item) => (item.Altfaaliyet = this.FormData.Altfaaliyet)
          );
          this.FormDatas.forEach(
            (item) => (item.Fileurl = this.FormData.Fileurl)
          );
          this.FormDatas.forEach(
            (item) => (item.Aciklama = this.FormData.Aciklama)
          );
          this.FormDatas.forEach(
            (item) => (item.Createdby = this.OPersonelid)
          );

          this.Post("StrOdenekTalep/postlist", this.FormDatas).then((res) => {
            if (res) {
              this.$bvModal.hide("StrOdenekTalep");
              this.FormData.Id = res.Data;
              this.$emit("TableUpdate");
            }
          });
        } else {
          if (this.FormDatas.length > 0) {
                      var count = 0;
            for (var Data in this.FormDatas) {

            count = count +1;
              if (this.FormDatas[Data].Id) {
                this.FormDatas[Data].GrupGuid = this.FormDatas[0].Grupguid;
                this.FormDatas[Data].Created = this.FormData.Tarih;
                this.FormDatas[Data].Createdby = this.FormData.Createdby;
                this.FormDatas[Data].Birimid = this.FormData.Birimid;
                this.FormDatas[Data].Yil = this.FormData.Yil;
                this.FormDatas[Data].Ay = this.FormData.Ay;
                this.FormDatas[Data].Gidertur = this.FormData.Gidertur;
                this.FormDatas[Data].Program = this.FormData.Program;
                this.FormDatas[Data].Altprogram = this.FormData.Altprogram;
                this.FormDatas[Data].Faaliyet = this.FormData.Faaliyet;
                this.FormDatas[Data].Altfaaliyet = this.FormData.Altfaaliyet;
                this.FormDatas[Data].Fileurl = this.FormData.Fileurl;
                this.FormDatas[Data].Aciklama = this.FormData.Aciklama;
                this.Update("StrOdenekTalep", this.FormDatas[Data]).then(
                  (res) => {
                    if (res) {
                      this.$emit("Update", this.FormData);
                                            if(this.FormDatas.length == count){

                                      this.$bvModal.hide("StrOdenekTalep");
                      }
                    }
                  }
                );
              } else {
                this.FormDatas[Data].GrupGuid = this.FormDatas[0].Grupguid;
                this.FormDatas[Data].Created = this.FormData.Tarih;
                              this.FormDatas[Data].Createdby = this.FormData.Createdby;
                this.FormDatas[Data].Birimid = this.FormData.Birimid;
                this.FormDatas[Data].Yil = this.FormData.Yil;
                this.FormDatas[Data].Ay = this.FormData.Ay;
                this.FormDatas[Data].Gidertur = this.FormData.Gidertur;
                this.FormDatas[Data].Program = this.FormData.Program;
                this.FormDatas[Data].Altprogram = this.FormData.Altprogram;
                this.FormDatas[Data].Faaliyet = this.FormData.Faaliyet;
                this.FormDatas[Data].Altfaaliyet = this.FormData.Altfaaliyet;
                this.FormDatas[Data].Fileurl = this.FormData.Fileurl;
                this.FormDatas[Data].Aciklama = this.FormData.Aciklama;
                this.FormDatas[Data].Created = this.FormData.Created;
                this.Post("StrOdenekTalep", this.FormDatas[Data]).then(
                  (res) => {
                    if (res) {
                      this.$emit("Update", this.FormData);
                      if(this.FormDatas.length == count){

                                      this.$bvModal.hide("StrOdenekTalep");
                      }
                    }
                  }
                );
              }

            }
          } else {
            this.$toast.error(
              "Minimum bir adet hesap kodu ve koda bağlı tutarları doldurunuz!"
            );
          }
        }
      } else {
        this.$toast.error("Açıklama ekleyiniz.");
      }
    },
    HesapKodsMethod(Gidertur){

            let Page= {
        PageNumber: "1",
        PageSize: "9999"
      }

      let Filter = "&Basamak=4";
this.FormDataType.Hesapkodid = []
this.FormDataType.Hesapkodids = []
      this.ActionsFilterGet({Service:"StrHesapKodlari",Page:Page, Filter:Filter}).then(res => {
        for(var i=0; i<res.Data.length; i++)
          {
            if (Gidertur == 1 && (res.Data[i].Kod.substring(0, 2) === "01" || res.Data[i].Kod.substring(0, 2) === "02")) {

              this.FormDataType.Hesapkodid.ComboDataArray.push({
                id: res.Data[i].Id,
                label: res.Data[i].Kod + " " + res.Data[i].Aciklama
              });
              this.FormDataType.Hesapkodid.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Kod + " " + res.Data[i].Aciklama})

            }

            if (Gidertur == 2) {
              this.FormDataType.Hesapkodid.ComboDataArray.push({
                id: res.Data[i].Id,
                label: res.Data[i].Kod + " " + res.Data[i].Aciklama
              });
              this.FormDataType.Hesapkodid.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Kod + " " + res.Data[i].Aciklama})

            }
          }
      });
    },
    GetFormDatas(Id) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.ActionsFilterGet({
        Service: "StrOdenekTalep/GetFormDatas",
        Page: Page,
        Filter: "&GrupGuid=" + Id,
      }).then((res) => {
        this.FormDatas = [];
        for (var data in res.Data) {
          this.FormDatas.push(res.Data[data]);
        }
      });
    },
    generateGUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    FileUpload() {
      var file = this.$refs.file.files[0];
      let x = file.name;
      var uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      );
      if (
        uzanti == "png" ||
        uzanti == "jpeg" ||
        uzanti == "jpg" ||
        uzanti == "doc" ||
        uzanti == "xml" ||
        uzanti == "pdf" ||
        uzanti == "xlsx"
      ) {
        let formData = new FormData();
        formData.append("file", file);
        this.ActionsPost({
          Service: "GenericFileUpDownload/UploadFile?pathUrl=Str",
          Data: formData,
        }).then((res) => {
          if (res.Succeeded == true) {
            this.FormData.Fileurl = res.Data.filename;
            this.$toast.success(this.$t("ToasMessage.FilePozitif"));
          } else {
            this.$toast.error(this.$t("ToasMessage.FileNegatif"));
          }
        });
      } else {
        this.$toast.error(this.$t("ToasMessage.FileNegatifUzanti"));
      }
    },
    Get() {
      this.$emit("TableUpdate");
      this.currentDate = new Date();
    },
    loadOptions({ action, callback }) {
      this.options = [];
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          this.options = this.hesapkodlari;

          callback(null, this.options);
        });
      }
    },
    AltProgramSecimi(Program) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.FormDataType.Altprogram.ComboDataArray = [];
      let Filter = "&Ustid=" + Program;

      this.ActionsFilterGet({
        Service: "StrProgramFaaliyetKodlari",
        Page: Page,
        Filter,
      }).then((res) => {
        for (var c = 0; c < res.Data.length; c++) {
          this.FormDataType.Altprogram.ComboDataArray.push({
            Id: res.Data[c].Id,
            Value: res.Data[c].Kod + "-" + res.Data[c].Aciklama,
          });
        }
      });
    },
    AltFaaliyetSecimi(Program) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.FormDataType.Altfaaliyet.ComboDataArray = [];
      let Filter = "&Ustid=" + Program;

      this.ActionsFilterGet({
        Service: "StrProgramFaaliyetKodlari",
        Page: Page,
        Filter,
      }).then((res) => {
        for (var c = 0; c < res.Data.length; c++) {
          this.FormDataType.Altfaaliyet.ComboDataArray.push({
            Id: res.Data[c].Id,
            Value: res.Data[c].Kod + "-" + res.Data[c].Aciklama,
          });
        }
      });
    },
    DeleteHesapKodu(index, id) {
      Swal.fire({
        title: this.$t("ToasMessage.DeletePopupBaslik"),
        text:
          "Ödenek Talep İçerisindeki Seçtiğiniz Hesap Kodu ve Ona Ait Bilgiler Silinecektir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: this.$t("ToasMessage.DeletePopupPozitif"),
        cancelButtonText: this.$t("ToasMessage.DeletePopupNegatif"),
      }).then((result) => {
        if (result.value) {
          this.FormDatas.splice(index, 1);
          this.FormData.Hesapkoduids.splice(index, 1);
          this.ActionsDelete({ Service: "StrOdenekTalep", Id: id }).then(
            (res) => {
              if (res.Succeeded == true) {
                this.$toast.success(this.$t("ToasMessage.DeletePozitif"));
              }
            }
          );
        }
      });
    },
    liste_yukle(veri) {
      let Page = {
        PageNumber: "1",
        PageSize: "50",
      };

      if (veri.length >= 1) {
        this.hesapkodlari = [];

        let Filter = "";
        if (veri[0] == "0" && veri[2] == ".") {
          Filter = "&Basamak=4&KodForLike=" + veri;
        } else {
          Filter = "&Basamak=4&Aciklama=" + veri;
        }

        this.ActionsFilterGet({
          Service: "StrHesapKodlari",
          Page: Page,
          Filter: Filter,
        }).then((res) => {
          for (var i = 0; i < res.Data.length; i++) {
if (this.FormData.Gidertur == 1) {
  if (res.Data[i].Kod.startsWith("01") || res.Data[i].Kod.startsWith("02")) {
    this.hesapkodlari.push({
      id: res.Data[i].Id,
      label: res.Data[i].Kod + " " + res.Data[i].Aciklama
    });
  }
} else {
  this.hesapkodlari.push({
    id: res.Data[i].Id,
    label: res.Data[i].Kod + " " + res.Data[i].Aciklama
  });
}


          }
        });
      }
    },
    onSelectionChange(selectedIds) {
      const previouslySelected = this.FormData.Hesapkoduids;
      const newlyAddedIds = selectedIds.filter(
        (id) => !previouslySelected.includes(id)
      );

      if (newlyAddedIds.length > 0) {
        const newId = newlyAddedIds[0];
        const secilenHesapKodu = this.Hesapkodlari.find((item) => item.id === newId);
        const secilenHesapKodu2 = this.Hesapkodlari2.find((item) => item.id === newId);
        if (!secilenHesapKodu) return;
        const newPrefix = secilenHesapKodu2.label.substring(0, 2);

        const mevcutPrefixler = this.FormDatas.map((f) => {
          const hesap = this.Hesapkodlari2.find((h) => h.id === f.Hesapkodid);
          return hesap ? hesap.label.substring(0, 2) : null;
        }).filter((p) => p !== null);

        if (
          mevcutPrefixler.length > 0 &&
          !mevcutPrefixler.includes(newPrefix)
        ) {
          this.$toast.error(
            "Seçilen hesap kodu mevcut seçimlerle uyumlu değil!"
          );
          return;
        }

        this.FormData.Hesapkoduids.push(newId);
        const newForm = {
          HesapKod: secilenHesapKodu.label,
          Hesapkodid: newId,
          Serbestodenek: null,
          Blokeodenek: null,
          Harcananodenek: null,
          Talepedilenodenek: null,
          Odemetutari: null,
        };
        this.FormDatas.push(newForm);
      }
    },
    liste_kontrol() {
      if (this.AddEdit == "Edit") {
        this.hesapkodlari = [];
        this.options = [];

        this.hesapkodlari.push({
          id: this.Id.Hesapkodlariid,
          label: this.Id.HesapKodAciklama,
        });

        this.options = this.hesapkodlari;
      }
    },
      updateKalanOdenek(index) {
    const data = this.FormDatas[index];
    const serbest = parseFloat(data.Serbestodenek) || 0;
    const harcanan = parseFloat(data.Harcananodenek) || 0;
    data.Kalanodenek = serbest - harcanan;
  },
        updateTalepEdilenOdenek(index) {
    const data = this.FormDatas[index];
        const serbest = parseFloat(data.Serbestodenek) || 0;
    const harcanan = parseFloat(data.Harcananodenek) || 0;
    const kalan = serbest - harcanan|| 0;
    const odemetutari = parseFloat(data.Odemetutari) || 0;
    data.Talepedilenodenek =  odemetutari- kalan ;
  },
      indir(file, filename) {
      let dosya_adi = file.substr(4, file.length - 4);
      let uzanti = file.substr(file.lastIndexOf(".") + 1);
      let Filter = "?fileName=" + dosya_adi + "&pathUrl=Str";

      this.ActionsFileGet({
        Service: "GenericFileUpDownload/DownloadFile",
        Filter,
      }).then((res) => {
        if (res) {
          /*
           var FILE = window.URL.createObjectURL(new Blob([res.Data]));

           var docUrl = document.createElement('x');
           docUrl.href = FILE;
           docUrl.setAttribute('download', 'file1.pdf');
           document.body.appendChild(docUrl);
           docUrl.click();
           */

          let blob = new Blob([res]);
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          if (filename == "") {
            link.download = dosya_adi;
            link.click();
          } else {
            link.download = filename + "." + uzanti;
            link.click();
          }
        }
      });
    },
  },
  created() {
    let YetkiSorgu = this.UserRolles.filter(
      (item) => item.includes("SuperAdmin") || item.includes("StrAdmin")
    );
    if (YetkiSorgu.length != 0) this.AdminRoleKontrol = true;


      this.ActionsFilterGet({Service:"StrHesapKodlari",Page:this.Page, Filter:"&Basamak=4"}).then(res => {
        for(var i=0; i<res.Data.length; i++)
          {
            this.Hesapkodlari.push ({id:res.Data[i].Id,label:res.Data[i].Aciklama})
                     this.Hesapkodlari2.push ({id:res.Data[i].Id,label:res.Data[i].Kod})
          }
      });
              let Filter = "&Eposta=" + this.UserEMail;
      this.ActionsFilterGet({
        Service: "OPersonel",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.OPersonelid = res.Data[0].Id;
      });
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrOdenekTalep"
      size="xl"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrOdenekTalep.AddEdit.FormTitleEdit')
          : $t('StrOdenekTalep.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <!-- {{ FormDatas }}

      <hr />
      {{ FormData }} -->
      <Form @submit.prevent="onSubmit">
        <div class="row">
          <div
            class="col-12 mb-3"
            v-if="this.FormData.Iptal == true || this.FormData.Revize == true"
          >
            <b-form-group label="İptal Açıklama">
              <b-form-input
                v-model="FormData.Iptalaciklama"
                type="text"
                step="0.01"
                min="0"
                disabled
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <BirimSecimi
              :title="FormDataType.Birimid.FieldTitle"
              :sutun="'0'"
              :title_class="'mb-3'"
              :selected="FormData.Birimid"
              :v="$v.FormData.Birimid"
              :YetkiKontrol="1"
              :multiple="false"
              :BirimTipId="null"
              @Secilmis_Idler="FormData.Birimid = $event"
            />
          </div>

          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Gidertur"
              :Value="FormData.Gidertur"
              :v="$v.FormData.Gidertur"
              @input="FormData.Gidertur = $event"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <formcombobox
              :key="FormData.Yil"
              :FormDataType="FormDataType.Yil"
              :Value="FormData.Yil"
              :v="$v.FormData.Yil"
              @input="FormData.Yil = $event"
            />
          </div>
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Ay"
              :Value="FormData.Ay"
              :v="$v.FormData.Ay"
              @input="FormData.Ay = $event"
            />
          </div>

          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Program"
              :Value="FormData.Program"
              :v="$v.FormData.Program"
              @input="(FormData.Program = $event), AltProgramSecimi($event)"
            />
          </div>
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Altprogram"
              :Value="FormData.Altprogram"
              :v="$v.FormData.Altprogram"
              @input="FormData.Altprogram = $event"
            />
          </div>
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Faaliyet"
              :Value="FormData.Faaliyet"
              :v="$v.FormData.Faaliyet"
              @input="(FormData.Faaliyet = $event), AltFaaliyetSecimi($event)"
            />
          </div>
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Altfaaliyet"
              :Value="FormData.Altfaaliyet"
              :v="$v.FormData.Altfaaliyet"
              @input="FormData.Altfaaliyet = $event"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <b-form-group
              class="mb-3"
              id="example text"
              label="Ekonomik Kodu"
              label-for="text"
            >
              <treeselect
                name="'Hesapkoduids'"
                id="'Hesapkoduids'"
                @search-change="liste_yukle($event)"
                :async="aktif_arama"
                :load-options="loadOptions"
                :options="FormDataType.Hesapkoduids.ComboDataArray"
                :multiple="true"
                :cacheOptions="false"
                searchPromptText="Aramak için yazın..."
                placeholder="Seçiniz..."
                v-model="Hesapkoduids"
                @input="onSelectionChange($event)"
              />
              <treeselect-value :value="Hesapkoduids" />
            </b-form-group>
          </div>
        </div>
        <div
          class="row mt-2 mb-2"
          v-for="(data, index) in FormDatas"
          :key="data.Id"
        >
          <div class="custom2-col mt-4">
            <div>{{ data.HesapKod }}</div>
          </div>
          <div class="custom-col">
            <b-form-group title="e-bütçeden">
              <template #label>
                Serbest Ödenek<br />
                <small class="d-block text-danger">(2. Düzey)</small>
              </template>

              <b-form-input
                v-model="data.Serbestodenek"
                type="number"
                step="100"
                min="0"
                placeholder="0.00"
                @input="
                  updateKalanOdenek(index), updateTalepEdilenOdenek(index)
                "
              ></b-form-input>
            </b-form-group>
          </div>
          <!--     <div class="custom-col">
            <b-form-group label="Bloke Ödenek"  title="e-bütçeden">
              <b-form-input
                v-model="data.Blokeodenek"
                type="number"
                step="0.01"
                min="0"
                placeholder="0.00"

              ></b-form-input>
            </b-form-group>
          </div> -->
          <div class="custom-col">
            <b-form-group title="e-bütçeden">
              <template #label>
                Harcanan Ödenek<br />
                <small class="d-block text-danger">(2. Düzey)</small>
              </template>

              <b-form-input
                v-model="data.Harcananodenek"
                type="number"
                step="100"
                min="0"
                placeholder="0.00"
                @input="
                  updateKalanOdenek(index), updateTalepEdilenOdenek(index)
                "
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="custom-col">
            <b-form-group title="e-bütçeden">
              <template #label>
                Kalan Ödenek<br />
                <small class="d-block text-danger">(2. Düzey)</small>
              </template>

              <b-form-input
                v-model="data.Kalanodenek"
                type="number"
                step="100"
                min="0"
                :class="{ disabled: true }"
                placeholder="0.00"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="custom-col">
            <b-form-group title="Ödeme emri belgesi/fatura tutarı">
              <template #label>
                Ödeme Tutarı<br />
                <small class="d-block text-danger">(4. Düzey)</small>
              </template>

              <b-form-input
                v-model="data.Odemetutari"
                type="number"
                step="0.01"
                min="0"
                placeholder="0.00"
                @input="updateTalepEdilenOdenek(index)"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="custom-col">
            <b-form-group title="e-bütçeden">
              <template #label>
                Talep Edilen Ödenek<br />
                <small class="d-block text-danger">(2. Düzey)</small>
              </template>

              <b-form-input
                v-model="data.Talepedilenodenek"
                type="number"
                step="100"
                          :class="{ disabled: true }"
                placeholder="0.00"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-1 text-align mt-4">
            <b-button
              class=" mt-3"
              variant="danger"
              @click="DeleteHesapKodu(index, data.Id)"
              ><i class="fas fa-trash-alt"></i
            ></b-button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <forminput
              :FormDataType="FormDataType.Aciklama"
              :Value="FormData.Aciklama"
              :v="$v.FormData.Aciklama"
              @input="FormData.Aciklama = $event"
            />
          </div>
        </div>
        <div class="row" v-if="AdminRoleKontrol == true && 1 == 0">
          <div class="col-md-12">
            <forminput
              :FormDataType="FormDataType.Onayaciklama"
              :Value="FormData.Onayaciklama"
              :v="$v.FormData.Onayaciklama"
              @input="FormData.Onayaciklama = $event"
            />
          </div>
        </div>
        <div class="row">
          <!-- <div class="col-md-10 mt-2">
            <label for="formFile" class="form-label">Dosya Ekle</label>
            <b-form-group class="mb-3 mt-">
              <input
                class="form-control"
                ref="file"
                type="file"
                v-on:change="FileUpload($event)"
                id="FormData.Fileurl"
                accept=".pdf, .doc, .png"
              />
            </b-form-group>
          </div> -->
          <div class="table-responsive">
            <table
              class="table table-striped table-bordered mb-0"
              v-if="this.AddEdit == 'Edit'"
            >
              <tbody>
                <tr>
                  <th scope="col">
                    {{ $t("StrKontrolGirisKanit.Table.KanitAdi") }}
                  </th>

                  <th scope="col"></th>
                </tr>
                <tr v-for="(Data, index) in TabloDetayVerileri" :key="index">
                  <td class="d-flex">
                    <div v-if="Data.Fileurl != '' && Data.Link == ''">
                      {{ Data.Filename }}
                    </div>
                    <div v-if="Data.Link != '' && Data.Fileurl == ''">
                      <a :href="Data.Link" target="blank">{{ Data.Link }}</a>
                    </div>
                    <div v-if="Data.Link != '' && Data.Fileurl != ''">
                      {{ Data.Filename }} <br />
                      <a :href="Data.Link" target="blank">{{ Data.Link }}</a>
                    </div>
                  </td>
                  <td>
                    <div v-if="Data.Fileurl != ''" class="row text-center">
                      <i
                        style="margin-left:10px"
                        @click="indir(Data.Fileurl, Data.Filename)"
                        class="fas fa-download"
                      >
                      </i>
                    </div>
                  </td>
                </tr>
                <tr v-if="FormData.Fileurl">
                  <td class="d-flex">
                    <div>
                      Mevcut Dosya
                    </div>
                  </td>
                  <td>
                    <div class="row text-center">
                      <a
                        v-if="FormData.Fileurl"
                        :href="
                          this.$config.FILES_URL + 'str/' + FormData.Fileurl
                        "
                        target="_blanl"
                      >
                        <i class="fas fa-eye" v-tooltip="'Dosya Görüntüle'"></i>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              class="alert alert-primary"
              role="alert"
              v-if="this.AddEdit == 'Add'"
            >
              Kayıt yaptıktan sonra kanıt dosyalarınızı listeleme ekranından
              ekleyebilirsiniz!
            </div>
          </div>
        </div>
        <button class="btn btn-primary mt-3" type="submit">
          {{ $t("StrOdenekTalep.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
<style>
.custom-col {
  flex: 0 0 14%; /* 1.5 sütuna denk gelir (12 sütunun %12.5'i) */
  max-width: 14%;
}
.custom2-col {
  flex: 0 0 21%; /* 1.5 sütuna denk gelir (12 sütunun %12.5'i) */
  max-width: 21%;
}
</style>
